/* eslint-disable @typescript-eslint/no-empty-function */
import { any, func, string } from 'prop-types';
import React from 'react';
import CheckedImg from 'Assets/images/pages/web-chat/checked.svg';
import { Image, Menu, MenuHeader, MenuItem, MenuMenu } from 'semantic-ui-react';

import css from './DevicePicker.less';

function SoundPicker({
  activeSpeaker,
  activeMicrophone,
  selectSpeaker,
  selectMicrophone,
  mics,
  speakers,
}) {
  return (
    <Menu vertical size="large">
      <MenuItem>
        <MenuHeader>
          <span className={css.header}>Select a Microphone</span>
        </MenuHeader>
        {mics.map(mic => (
          <MenuMenu key={mic.deviceId}>
            <MenuItem
              className={css.item}
              name={mic.label}
              active={activeMicrophone === mic.deviceId}
              onClick={() => selectMicrophone(mic.deviceId)}>
              {mic.label}
              {activeMicrophone === mic.deviceId && <Image src={CheckedImg} />}
            </MenuItem>
          </MenuMenu>
        ))}
      </MenuItem>
      <MenuItem>
        <MenuHeader>
          <span className={css.header}>Select a Speaker</span>
        </MenuHeader>
        {speakers.map(speaker => (
          <MenuMenu key={speaker.deviceId}>
            <MenuItem
              className={css.item}
              name={speaker.label}
              active={activeSpeaker === speaker.deviceId}
              onClick={() => selectSpeaker(speaker.deviceId)}>
              {speaker.label}
              {activeSpeaker === speaker.deviceId && <Image src={CheckedImg} />}
            </MenuItem>
          </MenuMenu>
        ))}
      </MenuItem>
    </Menu>
  );
}

SoundPicker.propTypes = {
  activeSpeaker: string,
  activeMicrophone: string,
  selectSpeaker: func,
  selectMicrophone: func,
  mics: any,
  speakers: any,
};

SoundPicker.defaultProps = {
  mics: [],
  speakers: [],
  activeSpeaker: 'default',
  activeMicrophone: 'default',
  selectSpeaker: () => {},
  selectMicrophone: () => {},
};

export default SoundPicker;
